<div *ngIf="data" class="d-flex gap-2">
  <div class="flex-grow-1">
    <strong>{{ data.title }}</strong>
    <div *ngFor="let line of data.lines">
      <span *ngIf="line.label">{{ line.label }}: </span>{{ line.value }}
    </div>
  </div>
  <div class="text-right">
    <button class="toast-close-button" type="button" (click)="close($event)">×</button>
  </div>
</div>
